import React from "react";

const Preloader = () => {
  return (
    <>
      {/* Preloader */}
      <div id="preloader">
        <div id="loader" />
      </div>
    </>
  );
};

export default Preloader;
